import FactFindingTabs from "./FactFindingTabs";
import InvestigationEntitiesContainer from "./InvestigationEntitiesContainer";


export const AnalysisPage: React.FC = () => {
    return (
        <div>
            <InvestigationEntitiesContainer />
            <FactFindingTabs />
        </div>
    )
}